import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const EXIT_MS = 240;

function SuccessToast({ message, durationMs = 3000, onDismiss, variant = 'success' }) {
  const [shown, setShown] = useState(null);
  const [exiting, setExiting] = useState(false);
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;
  const isError = variant === 'error';

  useEffect(() => {
    if (!message) {
      setShown(null);
      setExiting(false);
      return undefined;
    }
    setShown(message);
    setExiting(false);
    const hide = setTimeout(() => setExiting(true), durationMs);
    return () => clearTimeout(hide);
  }, [message, durationMs]);

  useEffect(() => {
    if (!exiting) return undefined;
    const done = setTimeout(() => {
      setShown(null);
      setExiting(false);
      if (onDismissRef.current) onDismissRef.current();
    }, EXIT_MS);
    return () => clearTimeout(done);
  }, [exiting]);

  if (!shown) return null;

  return createPortal(
    <div
      role={isError ? 'alert' : 'status'}
      data-testid={isError ? 'error-toast' : 'success-toast'}
      className={isError ? 'bm-success-toast bm-error-toast' : 'bm-success-toast'}
    >
      <div className={exiting ? 'bm-success-toast__card bm-success-toast__card--out' : 'bm-success-toast__card'}>
        <span className="bm-success-toast__mark" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
            {isError ? (
              <path
                d="M7 7 17 17 M17 7 7 17"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
              />
            ) : (
              <path
                d="M5 12.5 9.2 17 19 7"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            )}
          </svg>
        </span>
        <span className="bm-success-toast__text">{shown}</span>
      </div>
    </div>,
    document.body
  );
}

export default SuccessToast;
